import basement from "./assets/services/basement.jpg";
import curtains from "./assets/services/curtains.jpg";
import events from "./assets/services/events.jpg";
import furniture from "./assets/services/furniture.jpg";
import hallway from "./assets/services/hallway.jpg";
import maintenance from "./assets/services/maintenance.jpg";
import railing from "./assets/services/railing.jpg";
import windows from "./assets/services/windows.jpg";
import yard from "./assets/services/yard.jpg";

export const services = [
  {
    name: "Renovation cleaning",
    slug: "remontis-shemdgomi-dasufthaveba",
    img: maintenance,
    alt: "რემონტის შემდგომი პროფესიონალური დასუფთავება თბილისში",
    descKey: "renovation_desc",
    includesKey: "renovation_includes",
  },
  {
    name: "Event cleaning",
    slug: "ghonisdziebis-shemdgomi-dasufthaveba",
    img: events,
    alt: "ღონისძიებების შემდგომი დასუფთავება თბილისში",
    descKey: "event_desc",
    includesKey: "event_includes",
  },
  {
    name: "Chemical washing of furniture and carpets",
    slug: "avejis-da-xaligebis-qimwmenda",
    img: furniture,
    alt: "რბილი ავეჯისა და ხალიჩების ქიმწმენდა თბილისში",
    descKey: "furniture_desc",
    includesKey: "furniture_includes",
  },
  {
    name: "Vitrine and glass cleaning",
    slug: "vitrinebis-da-shushis-wmenda",
    img: windows,
    alt: "ვიტრინებისა და შუშების პროფესიონალური წმენდა თბილისში",
    descKey: "vitrine_desc",
    includesKey: "vitrine_includes",
  },
  {
    name: "Rental cleaning",
    slug: "binis-gaqiravebis-dasufthaveba",
    img: railing,
    alt: "ბინის გაქირავებამდე და გაქირავების შემდეგ დასუფთავება თბილისში",
    descKey: "rental_desc",
    includesKey: "rental_includes",
  },
  {
    name: "Hallway cleaning",
    slug: "sadarbazoebis-dasufthaveba",
    img: hallway,
    alt: "სადარბაზოებისა და დერეფნის დასუფთავება თბილისში",
    descKey: "hallway_desc",
    includesKey: "hallway_includes",
  },
  {
    name: "Basement cleaning",
    slug: "sardafebis-dasufthaveba",
    img: basement,
    alt: "სარდაფებისა და სათავსოების დასუფთავება თბილისში",
    descKey: "basement_desc",
    includesKey: "basement_includes",
  },
  {
    name: "Yard cleaning",
    slug: "ezos-dasufthaveba",
    img: yard,
    alt: "ეზოსა და გარე პერიმეტრის დასუფთავება თბილისში",
    descKey: "yard_desc",
    includesKey: "yard_includes",
  },
  {
    name: "Curtain cleaning",
    slug: "fardebis-wmenda",
    img: curtains,
    alt: "ფარდების პროფესიონალური წმენდა თბილისში",
    descKey: "curtain_desc",
    includesKey: "curtain_includes",
  },
  {
    name: "General cleaning",
    slug: "generaluri-dalageba",
    img: maintenance,
    alt: "გენერალური დალაგება და გაწმენდა თბილისში",
    descKey: "general_desc",
    includesKey: "general_includes",
  },
  {
    name: "Kitchen cleaning",
    slug: "samzareulos-dasufthaveba",
    img: events,
    alt: "სამზარეულოს ღრმა წმენდა და დეზინფექცია თბილისში",
    descKey: "kitchen_desc",
    includesKey: "kitchen_includes",
  },
  {
    name: "Bathroom cleaning",
    slug: "abazanis-dasufthaveba",
    img: railing,
    alt: "აბაზანის დასუფთავება და დეზინფექცია თბილისში",
    descKey: "bathroom_desc",
    includesKey: "bathroom_includes",
  },
];
